import { memo } from 'react';

import type { MetricEvent } from '@spotify-internal/csr-player';
import { Focusable } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';

import { formatPlaybackTime } from '../../../helpers';

import styles from './EventMarker.module.css';

export type EventMarkerData = MetricEvent & {
  position: number;
  color: string;
  label?: string;
};

type EventMarkerProps = {
  marker: EventMarkerData;
  onClick: (marker: MetricEvent) => void;
};

export const EventMarker = memo(({ marker, onClick }: EventMarkerProps) => {
  const formattedTime = formatPlaybackTime(marker.timestamp * 1000);
  const tooltipText = marker.label ?? `${marker.displayName} event`;
  return (
    <TooltipRoot>
      <Focusable>
        <button
          type="button"
          aria-label={`${tooltipText} at ${formattedTime}`}
          className={styles.marker}
          style={{
            left: `${marker.position}%`,
            background: marker.color,
          }}
          onClick={() => onClick(marker)}
          data-track-id="button.event-marker"
          data-track-action="seek"
          data-track-data-event-type={marker.name}
        />
      </Focusable>
      <Tooltip placement="bottom">
        {tooltipText}, {formattedTime}
      </Tooltip>
    </TooltipRoot>
  );
});
EventMarker.displayName = 'EventMarker';
